export const shouldFlagCardOverflow = (block, overlayHeight, blockHeight) =>
  block?.block_type !== "logo" && overlayHeight > blockHeight;

export const collectCardOverflowBlocks = (previewElement, blocks = []) => {
  const overflowing = new Map();
  if (!previewElement?.querySelectorAll) return overflowing;

  previewElement.querySelectorAll(".overlaytext").forEach((overlay) => {
    const blockElement = overlay.closest?.("[data-credit-block-index]");
    const frameElement = blockElement?.closest?.(".blockWrapper");
    const blockIndex = Number(blockElement?.dataset?.creditBlockIndex);

    if (!Number.isInteger(blockIndex) || !frameElement) return;

    if (
      shouldFlagCardOverflow(
        blocks[blockIndex],
        overlay.scrollHeight,
        frameElement.clientHeight,
      )
    ) {
      overflowing.set(blockIndex, {
        index: blockIndex,
        name: blocks[blockIndex]?.block_name || `Block ${blockIndex + 1}`,
      });
    }
  });

  return overflowing;
};
